import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Accordion, Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
    activebtn?: string;
}

export const AccordionCustom = styled(Accordion)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        border: none;
        box-shadow: none;
        border-radius: 0px !important;

        ::before {
            display: none;
        }

        &.Mui-expanded {
            margin: 0;
        }
        
        #panel1d-header {
            min-height: 0;
            height: auto;
            padding: 0 1.25rem 0 0;
            border-left: 3px solid ${theme?.palette.secondary.main};
            border-bottom: 1px solid ${theme?.palette.secondary.main};

            &.Mui-expanded {
                min-height: 0;
            }

            .MuiAccordionSummary-content {
                margin: 0;
                &.Mui-expanded {
                    margin: 0;
                }
            } 
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 100%;
        }
`);

export const Label = styled(Box)(
    ({ theme }: ParamsStyle) => `
        .title {
            font-size: .75rem;
            color: ${theme?.palette.primary.main};
        }

        .description {
            font-size: 1rem;
            margin-top: .5rem;
            color: ${theme?.palette.grey[400]};
        }

        label {
            display: flex;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);